export default "__VITE_ASSET__EHK1580N__"